import DistributorPricingModalTemplate from './../../controller/modal/distributor-pricing-modal.controller.html';
import DistributorPricingModalController from './../../controller/modal/distributor-pricing-modal.controller';
import SpiceIcoUrl from "../../../resources/icons/spice-grey.svg";

/* @ngInject */
export default function DistributorComponent($scope, $timeout, $location, $window, $uibModal, $translate, CacheService, BreadcrumbParserService, BrowseService,
                                             StepFileService, SpiceApiService, ImageProcessorService, UniquePartApiService, UniquePartModelService, OctopartApiService,
                                             NumberFormatterService, CurrencyFormatterService, NavigationService, NotifyingService, PromoSpaceApiService,
                                             QueryApiService, SleuthService, SpinnerLoadingService, DefinitionModelService, DocFinderFileService,
                                             DistributorService, PartCountFormatterService, ContainerInfoApiService, __env, APP_ROUTES,
                                             ParameterSupportService) {
    let hasRequestedParameterValues = false;
    let hasRequestedCountries = false;

    $scope.sleuthService = SleuthService;
    $scope.isBrowseCtrl = false;
    $scope.isTechnologyCtrl = false;
    $scope.isHomeCtrl = false;
    $scope.isDistributorCtrl = true;

    //Main page
    $scope.uniquePart = CacheService.getUniquePart();
    $scope.definition = CacheService.getDefinition();
    $scope.formattedTotalQuantity = 'Finding availability...';
    $scope.localCurrency = '$';
    $scope.highestMinimumOrderPrice = '--.--';

    //Mobile
    $scope.areDetailsHidden = false;
    $scope.expandedClass = true;
    $scope.collapsedClass = false;
    $scope.detailsAction = $translate.instant('label__cta__collapseButton').valueOf();

    //Pagination
    $scope.pageSize = 12;
    $scope.currentPage = 1;

    //Distributor
    $scope.distributors = [];
    $scope.sortSelection = $translate.instant('label__sort__option3__stock');
    $scope.regionSelection = {display: 'AMERICAS', value: 'AMERICA'};
    $scope.showRegionLists = false;
    $scope.showSortLists = false;
    $scope.distyImgSrc = '';
    $scope.countriesByRegion = [];
    $scope.hasBeenSearched = false;
    $scope.searchItem = {};
    $scope.hideStepFile = true;
    $scope.scipNumber = null;

    $scope.baseUrl = `/${__env.baseUrl}`.replace(/\/+$/, ''); // remove trailing slash
    $scope.intellidataApiUrl = __env.intellidataApiUrl;
    $scope.documentationUrl = __env.documentationUrl;

    //Promo
    PromoSpaceApiService.getPromosBySize('MEDIUM', function (promos) {
        $scope.promoSpace = promos[Math.floor(Math.random() * promos.length)];
    });

    $scope.SpiceIcoUrl = SpiceIcoUrl;

    // https://stackoverflow.com/a/16153231/4233452
    $scope.init = async function () {
        if (CacheService.getUniquePart()) {
            $scope.uniquePart = $scope.createShallowCopy(CacheService.getUniquePart());
        } else {
            $scope.uniquePart = {};
            $scope.uniquePart.uniquePn = $location.search().pn;
        }

        if ($scope.uniquePart.spice === undefined) {
            SpiceApiService.doesSpiceFileExist($scope.uniquePart);
        }

        if (SleuthService.getSleuthData() && SleuthService.getSleuthData().detectedUniqueParts !== undefined) {
            $scope.hasBeenSearched = SleuthService.getSleuthData().detectedUniqueParts.length === 1;
            $scope.searchItem = SleuthService.getSleuthDataFauxPart(CacheService.getDefinition().id);
        }

        UniquePartModelService.setObsoleteMessage($scope.uniquePart);

        $scope.definition = CacheService.getDefinition();

        if (CacheService.getParentDefinition() !== undefined && CacheService.getParentDefinition() !== null &&
            CacheService.getParentDefinition().length > 0) {
            const definitions = [...CacheService.getParentDefinition(), $scope.definition];
            UniquePartModelService.setSpecUrl(definitions, $scope.uniquePart);
            UniquePartModelService.setSpecProUrl(definitions, $scope.uniquePart);

            const previousDefinition = CacheService.getParentDefinition()[CacheService.getParentDefinition().length - 1];
            $scope.uniquePartContext = BreadcrumbParserService.parseBreadcrumbToSentence(previousDefinition);
        }

        $scope.uniquePnAliases = DistributorService.getAliasesForDisplay($scope.uniquePart);
        $scope.formattedMessageText = $scope.formatMessageText($scope.uniquePart.message);

        ImageProcessorService.processImagesAndDefinitions($scope.uniquePart.series, [$scope.definition]);

        // It seems like duplicate code check SleuthService.getSeriesImage over write CacheService.getDefintion()
        // if not delete below code.
        $scope.definition = CacheService.getDefinition();
        $scope.isSleuthResult = SleuthService.getSleuthData() !== undefined;
        $scope.copiedUniquePart = $scope.uniquePart.uniquePn;

        $scope.uniquePart.partCountDisplay = $translate.instant('message__findingAvailability');
        $scope.uniquePart.allRegionPartCountDisplay = $translate.instant('message__findingAvailability');

        if (!hasRequestedParameterValues) {
            hasRequestedParameterValues = !hasRequestedParameterValues;
            UniquePartApiService.getParameterValuesByDisplayArea($scope.uniquePart.uniquePn, 'COMPONENT_EDGE_PART_DETAIL',
                function (values) {
                    //suppress the special parameters and Datasheet parameter
                    for (let i = values.length - 1; i >= 0; i--) {
                        if (ParameterSupportService.isSpecialParameter(values[i].parameterName) || values[i].parameterName.toUpperCase() === 'SCIP NUMBER') {
                            if (values[i].parameterName.toUpperCase() === 'SCIP NUMBER') {
                                $scope.scipNumber = values[i].value;
                            }
                            values.splice(i, 1);
                        }
                    }
                    $scope.values = values;
                }
            );
        }

        if (!hasRequestedCountries) {
            hasRequestedCountries = !hasRequestedCountries;
            // add a conditional statement fot https://kemetelectronics.atlassian.net/browse/IST-368
            if ($scope.uniquePart.superAlias === undefined && $scope.uniquePart.aliases === undefined) {
                await getUniquePartAsync($scope.uniquePart.uniquePn);
            }
            OctopartApiService.getCountries(function (countries) {
                $scope.countries = countries;
                OctopartApiService.getOctopartDistInfo($scope.uniquePart, function (distributors) {
                    DistributorService.removeZeroQuantityDistributor(distributors.octoParts);
                    const arraySize = distributors.octoParts !== undefined ? distributors.octoParts.length : 0;
                    let totalParts = 0;
                    let referenceObj = {
                        price: 0
                    };
                    if (distributors.userRegion !== undefined) {
                        $scope.setRegionSelection(distributors.userRegion.region);
                    }

                    for (let i = 0; i < arraySize; i++) {
                        distributors.octoParts[i].prices.isCollapsed = true;
                        distributors.octoParts[i].quantityDisplay = '';

                        (function (inner_i) {
                            const quant = $scope.formatQuantity(distributors.octoParts[inner_i].quantity);
                            let number;
                            (quant === '0') ? number = 'No' : number = quant;
                            $translate('label__inventory__big', {
                                numberOf: number
                            }).then(function (value) {
                                distributors.octoParts[inner_i].quantityDisplay = value.valueOf();
                            })['catch'](function (error) {
                                console.error(error);
                            });
                        })(i);
                        totalParts = (distributors.octoParts[i].quantity + totalParts);

                        const arrayOfPrices = distributors.octoParts[i].prices.prices;
                        const highestPrice = DistributorService.findMinOrderQtyAndPrice(arrayOfPrices, distributors.octoParts[i].minOrderQty);

                        if (highestPrice !== undefined && referenceObj.price < highestPrice.price) {
                            highestPrice.currency = distributors.octoParts[i].prices.currency;
                            referenceObj = highestPrice;
                        }
                    }

                    if (arraySize !== 0) {
                        $scope.highestMinimumOrderPrice = referenceObj.price + ' ' + referenceObj.currency;
                    } else {
                        $scope.highestMinimumOrderPrice = '-.--';
                    }

                    if (distributors.userRegion !== undefined && distributors.userRegion.region === 'EMEA') {
                        $scope.localCurrency = '€';
                    } else if (distributors.userRegion !== undefined && distributors.userRegion.region === 'ASIA') {
                        $scope.localCurrency = '¥';
                    }

                    $scope.uniquePart.totalParts = totalParts;
                    $scope.uniquePart.partCountDisplay = PartCountFormatterService.formatAvailability($scope.uniquePart);

                    // Grab quantities for unique parts with no count.
                    const uniqueParts = [];
                    uniqueParts.push($scope.uniquePart);
                    if (uniqueParts.length > 0) {
                        OctopartApiService.getOctoPartQuantities(uniqueParts, function (octoQuantities) {
                            // console.log(octoQuantities);
                            let found = false;
                            for (let j = 0; j < octoQuantities.length; ++j) {
                                if ($scope.uniquePart.displayPn === octoQuantities[j].mpn ||
                                    $scope.uniquePart.displayPn.replace(/-/g, '') === octoQuantities[j].mpn || // Compare without dashes
                                    $scope.uniquePart.displayPn.replace(/ /g, '') === octoQuantities[j].mpn) { // Compare without spaces
                                    found = true;
                                    $scope.uniquePart.allRegionTotalParts = octoQuantities[j].quantity;
                                    break;
                                }
                            }

                            if (!found) {
                                // Make sure don't overwrite already processed uniqueParts
                                if ($scope.uniquePart.allRegionTotalParts === undefined) {
                                    $scope.uniquePart.allRegionTotalParts = 0;
                                }
                            }
                            $scope.uniquePart.allRegionPartCountDisplay = PartCountFormatterService.formatAllRegionAvailability($scope.uniquePart);
                        });
                    }

                    // $scope.formattedTotalQuantity = $scope.formatNumber(totalParts);
                    $scope.quantitySuffix = 'Inventory Available';
                    $scope.distributors = distributors.octoParts;

                    $scope.countriesByRegion = $scope.setCountriesByRegion();
                    $scope.countriesByRegion.forEach(function (country) {
                        if (distributors.userRegion !== undefined && country.code === distributors.userRegion.countryCode) {
                            $scope.countrySelection = country;
                        }
                    });
                });
            });
        }

        if (document.documentElement.addEventListener) {
            document.documentElement.addEventListener('click', function () {
                document.getElementsByClassName('dropdown-wrapper').forEach(dropdown => angular.element(dropdown).removeClass('active'))
            });
        } else {
            document.documentElement.attachEvent('onclick', function () {
                document.getElementsByClassName('dropdown-wrapper').forEach(dropdown => angular.element(dropdown).removeClass('active'))
            });
        }
        $scope.hideStepFile = $scope.isStepFileUnavailable($scope.uniquePart);

        for (var i = 0; i < UniquePartModelService.getCompareQueue().length; ++i) {
            if (UniquePartModelService.getCompareQueue()[i].uniquePn === $scope.uniquePart.uniquePn) {
                $scope.uniquePart = UniquePartModelService.getCompareQueue()[i];
                break;
            }
        }
    };

    $scope.createShallowCopy = function (src) {
        const copy = Object({});
        const regex = new RegExp('^\\$+', 'g');
        for (const prop in src) {
            if (Object.prototype.hasOwnProperty.call(src, prop)) {
                if (!prop.match(regex)) {
                    copy[prop] = src[prop];
                } // strip out angular props
            }
        }
        return copy;
    };

    $scope.setRegionSelection = function (region) {
        if (region === 'AMERICA') {
            $scope.regionSelection.display = 'AMERICAS';
            $scope.regionSelection.value = region;
        } else {
            $scope.regionSelection.display = region;
            $scope.regionSelection.value = region;
        }
    };

    $scope.isStepFileUnavailable = function (uniquePart) {
        if (uniquePart !== undefined) {
            return !StepFileService.isStepFileAvailable(uniquePart);
        } else {
            return true;
        }
    };

    $scope.isKSIMSupported = function (uniquePart) {
        if (uniquePart != null) {
            return ParameterSupportService.isKSIMSupported(uniquePart);
        } else {
            return false;
        }
    };

    $scope.isLifeCalcAvailable = function (uniquePart) {
        if (uniquePart != null) {
            return ParameterSupportService.isLifeCalculatorSupported(uniquePart);
        } else {
            return false;
        }
    };

    $scope.isEngineeringKit = function () {
        const previousDefinition = CacheService.getParentDefinition()[CacheService.getParentDefinition().length - 1];
        return previousDefinition != null && previousDefinition.id === 706;
    }

    $scope.formatNumber = function (number) {
        const formattedNumber = DistributorService.formatLargeNumber(number);
        return (formattedNumber === 0) ? 'No ' : formattedNumber;
    };

    $scope.formatMessageText = function (message) {
        if (message !== null && message !== undefined && message.text !== null && message.text !== undefined) {
            let closeBold = false;
            while (message.text.indexOf('*') > 0) {
                if (!closeBold) {
                    message.text = message.text.replace('*', '<b>');
                    closeBold = true;
                } else {
                    message.text = message.text.replace('*', '</b>');
                    closeBold = false;
                }
            }
            return message.text;
        } else {
            return message;
        }
    };

    if (CacheService.getDefinition() && CacheService.getUniquePart()) {
        $scope.init();
    } else {
        DefinitionModelService.getModelInit();
    }

    $scope.handleSleuthChanges = function () {
        if ($location.path() === APP_ROUTES.PART_DETAIL.path) {
            hasRequestedParameterValues = false;
            hasRequestedCountries = false;
            $scope.init();
        }
    };

    NotifyingService.subscribeToSleuthChanges($scope, $scope.handleSleuthChanges);
    NotifyingService.subscribeToModelServiceInit($scope, $scope.init);

    $scope.handleDropdownClick = function (event) {
        event.stopPropagation();
        const dropdown = document.getElementsByClassName('dropdown-wrapper');
        for (let i = 0; i < dropdown.length; i++) {
            const target = (dropdown[i] === event.target) ? event.target : event.target.parentElement;
            if (dropdown[i] === target) {
                (angular.element(dropdown[i]).hasClass('active'))
                    ? angular.element(dropdown[i]).removeClass('active')
                    : angular.element(dropdown[i]).addClass('active');
            } else angular.element(dropdown[i]).removeClass('active');
        }
    };

    $scope.displayDefinitionName = function (definition) {
        if (definition === undefined) {
            return '';
        }
        if (CacheService.getConfigurationInfo() !== undefined) {
            const displayName = ContainerInfoApiService.getDisplayName(definition, CacheService.getConfigurationInfo().language);
            if (displayName === null) {
                return definition.displayName;
            } else {
                return displayName;
            }
        } else {
            if (definition !== undefined) {
                return definition.displayName;
            } else {
                return ''; // in the case where the view is rendering, and we don't have a definition yet.
            }
        }
    };

    $scope.collapseOnBlur = function (event) {
        //console.log(event);
        document.getElementsByClassName('dropdown-wrapper').forEach(dropdown => angular.element(dropdown).removeClass('active'));
    };

    $scope.sortOptionChange = function (translationId) {
        $scope.sortSelection = '';

        $translate(translationId).then(function (option) {
            $scope.sortSelection = option.valueOf();
        });
    };

    $scope.sortDistribution = function (distributor) {
        if ($scope.sortSelection === $translate.instant('label__sort__option1__highest').valueOf()) {
            return -distributor.prices.prices[distributor.prices.prices.length - 1].price;
        } else if ($scope.sortSelection === $translate.instant('label__sort__option2__lowest').valueOf()) {
            return distributor.prices.prices[distributor.prices.prices.length - 1].price;
        } else {
            return -distributor.quantity;
        }
    };

    $scope.outputPrice = function (position, prices) {
        // This is a hacky solution. It just checks if it's USD and puts a dollar sign. TODO We'll want to accommodate other countries too.
        const currency = CurrencyFormatterService.getCurrencySymbol(prices.currency);
        if (position.match(/(low)/i)) {
            return currency + prices.prices[prices.prices.length - 1].price;
        } else if (position.match(/(high)/i)) {
            return currency + prices.prices[0].price;
        } else {
            console.error('The position of Output Price must be either low/lowest or high/highest.');
            return '--';
        }
    };

    $scope.showDetails = function () {
        if ($scope.areDetailsHidden) {
            $scope.areDetailsHidden = !$scope.areDetailsHidden;
            $scope.expandedClass = !$scope.expandedClass;
            $scope.collapsedClass = !$scope.collapsedClass;
            $scope.detailsAction = $translate.instant('label__cta__collapseButton');
        } else {
            $scope.areDetailsHidden = !$scope.areDetailsHidden;
            $scope.expandedClass = !$scope.expandedClass;
            $scope.collapsedClass = !$scope.collapsedClass;
            $scope.detailsAction = $translate.instant('label__cta__expandButton');
        }
    };

    $scope.fetchPrevious = function (current) {
        $location.search('pn', null);
        $location.search('id', CacheService.getDefinition().id);
        ImageProcessorService.processImagesAndDefinitions($scope.uniquePart.series, [CacheService.getDefinition()]);
        $timeout(
            function () {
                $scope.$apply(function () {
                    $location.path('/browsing/technology');
                });
            },
            10
        );
    };

    $scope.populateQuantityDisplay = function (distributors) {
        const arraySize = distributors !== undefined ? distributors.length : 0;
        for (let i = 0; i < arraySize; ++i) {
            distributors[i].quantityDisplay = '';

            (function (inner_i) {
                const quant = $scope.formatQuantity(distributors[inner_i].quantity);
                let number;
                (quant === '0') ? number = 'No' : number = quant;
                $translate('label__inventory__big', {
                    numberOf: number
                }).then(function (value) {
                    distributors[inner_i].quantityDisplay = value.valueOf();
                })['catch'](function (error) {
                    console.error(error);
                });
            })(i);
        }
    };

    function distributors() {
        return function (distributors, highestMinimumOrderPrice, localCurrency, totalParts) {
            $scope.highestMinimumOrderPrice = highestMinimumOrderPrice;
            $scope.localCurrency = localCurrency;
            $scope.uniquePart.totalParts = totalParts;
            $scope.uniquePart.partCountDisplay = PartCountFormatterService.formatAvailability($scope.uniquePart);
            $scope.populateQuantityDisplay(distributors);
            $scope.distributors = distributors;
        };
    }

    $scope.handleCountrySelection = function (country) {
        if ($scope.countrySelection.code !== country.code) {
            $scope.countrySelection = country;
            DistributorService.findDistributors($scope.uniquePart, $scope.regionSelection.value, $scope.countrySelection.code,
                distributors());
        }
    };

    $scope.handleRegionSelection = function (region) {
        if ($scope.regionSelection.value !== region) {
            $scope.setRegionSelection(region);
            $scope.countrySelection = {name: 'Select Country ', code: ''};
            const countryCode = DistributorService.getDefaultCountryCode($scope.regionSelection.value);
            $scope.countriesByRegion = $scope.setCountriesByRegion();
            $scope.countrySelection = DistributorService.getDefaultCountry($scope.regionSelection.value, $scope.countriesByRegion);

            DistributorService.findDistributors($scope.uniquePart, $scope.regionSelection.value, countryCode,
                distributors());
        }
    };

    $scope.setCountriesByRegion = function () {
        return $scope.countries[$scope.regionSelection.value];
    };

    $scope.pageChangeHandler = function (num) {
        console.log('going to page ' + num);
    };

    $scope.sleuthDataComparison = function (searchLabel) {
        $translate(searchLabel, 'en').then(function (value) {
            let fauxPart = null;
            for (let i = 0; i < UniquePartModelService.getCompareQueue().length; ++i) {
                if (UniquePartModelService.getCompareQueue()[i].uniquePn === 'Search') {
                    fauxPart = UniquePartModelService.getCompareQueue()[i];
                    break;
                }
            }
            if (fauxPart == null) {
                fauxPart = SleuthService.getSleuthDataFauxPart(CacheService.getDefinition().id, value.valueOf());
            }
            $scope.selectForComparison(fauxPart);
        });
    };

    $scope.selectForComparison = function (uniquePart) {
        const errorMessage = UniquePartModelService.updateComparison(uniquePart);

        if (errorMessage != null) {
            alert(errorMessage);
        }
    };

    $scope.openPricingPopup = function (distributor) {
        const modalInstance = $uibModal.open({
            controller: DistributorPricingModalController.name,
            templateUrl: DistributorPricingModalTemplate,
            scope: $scope,
            size: 'md',
            resolve: {
                distributor: function () {
                    return distributor;
                }
            }
        });
        modalInstance.result.then(
            () => void 0,
            () => {
                console.log('Modal dismissed at: ' + new Date());
            }
        ).catch(reason => console.log(`Modal dismissed at: ${new Date()} for ${reason}`));
    };

    $scope.buildStepUrl = function (uniquePn) {
        if (uniquePn != null) {
            return DocFinderFileService.buildStepUrl(uniquePn);
        }
    };

    $scope.onSTEPClick = function (event, uniquePart) {
        $scope.trackStepDownload(uniquePart.uniquePn, `${uniquePart.uniquePn}.step`);
    };

    $scope.viewAlternateParts = function () {
        SpinnerLoadingService.showLoading();

        // Get all parameter values for alternative parts function
        UniquePartApiService.getParameterValues($scope.uniquePart.uniquePn, function (parameterValues) {
            $scope.uniquePart.parameterValues = parameterValues;
            UniquePartModelService.getAlternativeParts($scope.uniquePart, function (sharedDefinitionParameterValues) {

                const query = SleuthService.buildQueryParam([$scope.uniquePart.leafDefinitionId], sharedDefinitionParameterValues);

                QueryApiService.executeParameterValueSearch(query, function (response) {
                    SleuthService.storeSleuthData(response);
                    SleuthService.buildQueryData(response);
                    NavigationService.openMenu();
                    SpinnerLoadingService.hideLoading();
                    $location.path('/browsing/technology');
                });

            });
        });
    };

    $scope.$parent.isopen = ($scope.$parent['default'] === $scope.item);
    $scope.$watch('isopen', function (newValue, oldValue, scope) {
        scope.$parent.isopen = newValue;
    });

    $scope.toggleOpen = function () {
        console.log('Open');
    };

    if ($scope.uniquePart !== undefined) {
        // 06-29-2020 Kevin: Tim said that doc finder has been dead for a few years now, and to disable this.
        // DocFinderFileService.buildRohsUrl($scope.uniquePart, 'Brand', function (result) {
        //     $scope.docFinderUrl = result;
        // });
        $scope.dataSheetUrl = DocFinderFileService.buildDataSheetUrl($scope.uniquePart);
    }
    $scope.$watch(function (scope) {
        return scope.uniquePart;
    }, function (newValue, oldValue) {
        if (newValue !== oldValue) {
            // 06-29-2020 Kevin: Tim said that doc finder has been dead for a few years now, and to disable this.
            // DocFinderFileService.buildRohsUrl(newValue, 'Brand', function (result) {
            //     $scope.docFinderUrl = result;
            // });
            $scope.dataSheetUrl = DocFinderFileService.buildDataSheetUrl(newValue);
        }
    });

    $scope.roHSCompliance = function () {
        if ($scope.values !== undefined) {
            for (let i = 0; i < $scope.values.length; i++) {
                if ($scope.values[i].parameterName.toUpperCase() === 'ROHS') {
                    switch ($scope.values[i].value.toUpperCase()) {
                        case 'YES' :
                            return 1;
                        case 'NO':
                            // If no RoHS and no Pro65
                            if ($scope.uniquePart.series !== undefined &&
                                ($scope.uniquePart.series.value === 'T555' || $scope.uniquePart.series.value === 'T556') &&
                                $scope.uniquePart.displayPn.length >= 14 && $scope.uniquePart.displayPn.substr(12, 2) === 'AT') {
                                return 2;
                            }
                            return 0;
                    }
                    return 3;
                }
            }
        }
        return null;
    };

    $scope.removeSleuthData = function () {
        SleuthService.removeSleuthData();
    };

    $scope.clearSearchBar = function () {
        CacheService.storeOriginalQueryInput(undefined);
    };

    $scope.formatQuantity = function (number) {
        return NumberFormatterService.displayCommaSeparated(number);
    };

    /* GOOGLE ANALYTICS TRACKING */
    $scope.trackDataSheet = function (title, url) {
        if ($window.ga) {
            $window.ga('send', {
                hitType: 'event',
                eventCategory: 'PDF',
                eventAction: 'view_datasheet',
                eventLabel: 'Part: ' + title + '; URL: ' + url
            });
        }
    };

    $scope.trackRohsDownload = function (title, pdf) {
        if ($window.ga) {
            $window.ga('send', {
                hitType: 'event',
                eventCategory: 'ROHS',
                eventAction: 'download',
                eventLabel: 'Part: ' + title + '; ROHS: ' + pdf
            });
        }
    };

    $scope.trackSpecSheet = function (title, url) {
        if ($window.ga) {
            $window.ga('send', {
                hitType: 'event',
                eventCategory: 'PDF',
                eventAction: 'view_specsheet',
                eventLabel: 'Part: ' + title + '; URL: ' + url
            });
        }
    };

    $scope.trackProSpecSheet = function (title, url) {
        if ($window.ga) {
            $window.ga('send', {
                hitType: 'event',
                eventCategory: 'PDF',
                eventAction: 'view_pro-specsheet',
                eventLabel: 'Part: ' + title + '; URL: ' + url,
            });
        }
    };

    $scope.trackStepDownload = function (title, stepFile) {
        if ($window.ga) {
            $window.ga('send', {
                hitType: 'event',
                eventCategory: 'STEP',
                eventAction: 'download',
                eventLabel: 'Part: ' + title + '; STEP: ' + stepFile
            });
        }
    };

    $scope.trackKSIMNavigation = function (title, message) {
        if ($window.ga) {
            $window.ga('send', {
                hitType: 'event',
                eventCategory: 'KSIM',
                eventAction: 'navigate',
                eventLabel: 'Part: ' + title + '; Message: ' + message
            });
        }
    };

    $scope.trackDocFinderUse = function (title, url) {
        if ($window.ga) {
            $window.ga('send', {
                hitType: 'event',
                eventCategory: 'PDF',
                eventAction: 'use_docfinder',
                eventLabel: 'Part: ' + title + '; URL: ' + url
            });
        }
    };

    $scope.trackExternalDistributorClick = function (distributor) {
        if ($window.ga) {
            $window.ga('send', {
                hitType: 'event',
                eventCategory: 'External',
                eventAction: 'Buy Click',
                eventLabel: distributor + ' Click'
            });
        }
    };


    /**
     * Handle Home Click
     *
     * Handles the redirection of linking home for mobile especially.
     */
    $scope.handleHomeClick = function () {
        $location.path('/');
    };

    /**
     * Check to see if the series is supported by the Inductor Loss Calculator.
     * If it is, then link the user to the web application.**/
    $scope.isSeriesInInductorLossCalculator = function (series) {
        const supportedSeries = ['MPC', 'MPCG', 'MPCH', 'MPLC', 'MPLCG', 'MPLCH'];
        return supportedSeries.indexOf(series) >= 0;
    };

    $scope.getDisplayParameterName = function (parameterValue) {
        let displayParameterName = ContainerInfoApiService.getDisplayNameByDisplayNames(parameterValue.parameterDisplayNames,
            CacheService.getConfigurationInfo().language);
        if (displayParameterName == null) {
            displayParameterName = ContainerInfoApiService.getDisplayNameByDisplayNames(parameterValue.parameterDisplayNames,
                'ENGLISH');
        }
        return displayParameterName;
    };

    $scope.getLanguageValue = function (paramValue) {
        let displayParameterValueName = ContainerInfoApiService.getDisplayNameByDisplayNames(paramValue.displayNames,
            CacheService.getConfigurationInfo().language);
        if (displayParameterValueName == null) {
            displayParameterValueName = paramValue.formattedValue;
        }
        return displayParameterValueName;
    };

    $scope.displayDefinitionName = function (definition) {
        if (definition === undefined) {
            return '';
        }
        if (CacheService.getConfigurationInfo() !== undefined) {
            const displayName = ContainerInfoApiService.getDisplayName(definition, CacheService.getConfigurationInfo().language);
            if (displayName === null) {
                return definition.displayName;
            } else {
                return displayName;
            }
        } else {
            return definition.displayName;
        }
    };

    // use async/await to solve https://kemetelectronics.atlassian.net/browse/CE-812
    function getUniquePartAsync(uniquePn) {
        return new Promise(function (resolve, reject) {
            UniquePartApiService.getUniquePart(uniquePn, function (result) {
                if (result) {
                    resolve(result)
                    $scope.uniquePart.superAlias = result.superAlias;
                    $scope.uniquePart.aliases = result.aliases;
                } else {
                    console.error("Can't get result from getUniquePart")
                }
            });
        });
    }
}
